module.exports = __webpack_public_path__ + "static/media/replaceIcon.260c26a5.png";